module.exports = __webpack_public_path__ + "img/very-botsad.734adb17.png";